
import SectionHeading from "@/components/common/SectionHeading";
import ContactInfo from "./ContactInfo";
import ContactForm from "./ContactForm";

const ContactHero = () => {
  return (
    <section className="bg-ecofor-light-blue/30 py-12 md:py-16">
      <div className="container">
        <SectionHeading 
          title="Contact" 
          subtitle="Le GIP ECOFOR coordonne le projet FORESTT-HUB. N'hésitez pas à nous contacter pour toute information."
        />
        
        <div className="max-w-5xl mx-auto mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
